exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Analysis-Indicators-___style__wrapper___1AFF0{height:41px;justify-content:flex-start;align-items:center}.src-components-Analysis-Indicators-___style__wrapper___1AFF0>div{margin-right:7.5px}.src-components-Analysis-Indicators-___style__wrapper___1AFF0>div:first-of-type{margin-left:-9px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Analysis-Indicators-___style__wrapper___1AFF0"
};